<template>
  <v-menu offset-x right :close-on-content-click="false" v-model="open">
    <template v-slot:activator="{ on }">
      <v-list-item v-on="on"><v-list-item-title>Edit</v-list-item-title></v-list-item>
    </template>
    <v-card flat width="350">
      <v-card-title>Batch edit</v-card-title>
      <v-card-text class="pa-0">
        <v-container class="pt-0 px-6">
          <v-row dense align="center">
            <v-col cols="12">
              <account-picker v-model="input.inventoryAccountRef" label="Inventory asset account"
                              :accounts="accounts" :addTypes="['OtherCurrentAsset']" hint="">
              </account-picker>
            </v-col>
          </v-row>
        </v-container>
        <v-divider/>
      </v-card-text>
      <v-card-actions class="px-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="open=false">Cancel</v-btn>
        <v-btn color="primary" @click="save" :loading="saving">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>

export default {
  name: 'InventoryCasksBatchEdit',
  props: {
    casks: {type:Array, required:true}
  },
  data() {
    return {
      open: false,
      input: {updateAccount: true,
              inventoryAccountRef:'',
              casks:[]},
      accounts: [],
      saving: false
    }
  },
  computed: {
    connectedToAccounting() {
      return this.$store.getters.company.connectedToAccounting;
    },
    values() {
      return this.$store.getters.company.permissions.includes('values') && this.$store.getters.company.settings.useAccounts;
    }
  },
  async created() {
    if (!this.connectedToAccounting)
      return;

    const results = await this.$apiCall(`query InventoryCasksBatchEdit($currency: String!) {
                                            companyAccounts {caskInventory}
                                            accounts(currency:$currency) {
                                              ref,name,type
                                            }
                                          }`,
                                        {currency:this.$store.getters.company.settings.homeCurrency});
    if (!results.error) {
      this.accounts = results.data.accounts.filter(account => account.type === 'OtherCurrentAsset');
      this.input.inventoryAccountRef = results.data.companyAccounts.caskInventory;
    }
  },
  methods: {
    async save() {
      this.saving = true;
      this.input.casks = this.casks.map(cask => cask.id);
      const results = await this.$apiCall(`mutation InventoryCasksBatchEdit($input: CaskBatchUpdateInput!) {
                                              casksBatchUpdate(input:$input) {id,error}
                                            }`,
                                          {input:this.input});
      this.saving = false;
      if (!results.error) {
        this.open = false;
        const errorCount = results.data.casksBatchUpdate.length;
        this.$store.commit('setError', {type:errorCount ? 'warning' : 'success',
                                        message:`Updated ${this.casks.length - errorCount} of ${this.casks.length} casks\
                                                  ${errorCount ? `(${errorCount} error${errorCount > 1 ? 's':''})` : ``}`});
        this.$emit('refresh', results.data.casksBatchUpdate);
      }
    }
  }
}
</script>